import React from 'react';
import { withAssetSelector } from '../../../../../Uploader';
import AssetPreview from '../../../../../AssetPreview';

function CommentAssetPreview({ asset }) {
  return <AssetPreview asset={asset} height={90} width={90} />;
}

export default withAssetSelector(CommentAssetPreview);